import axios from "axios";
import router from "./router";

let pathname = window.location.origin.split("//")[1];

const api = axios.create({
  baseURL: pathname.includes("localhost")
    ? "http://localhost:3004/api"
    : `https://${pathname}:3004/api`,
});

api.interceptors.request.use(
  async (config) => {
    try {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        if (parsedUser.token) {
          config.headers["x-master-token"] = parsedUser.token;
          config.headers["api_key"] = parsedUser.api_key;
        }
      }
    } catch (error) {
      console.error("Failed to attach auth headers:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      router.push("/login?session_expired=1");
    }
    return Promise.reject(error);
  }
);

export default api;
